import { useState, useEffect } from "react";
import useFetch, { FetchRequest } from "../../../../../../../../_helpers/UseFetchHook";
import { FetchResponse } from "../../../../../../../../_helpers/Types";
import { Constants } from "../../../../../../../../_helpers/Constants";

const UseGetLodgingVendors = (request?: GetLodgingVendorsRequest) => {
  // const [data, setData] = useState<GetLodgingVendorsResponse | null>(null);
  const [data, setData] = useState<any[] | null>(null);
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const [fetchRequest, setFetchRequest] = useState<FetchRequest>();
  const fetchResponse = useFetch(fetchRequest);
  const apiString = Constants.apiUrl;

  useEffect(() => {
    if (request) {
      const url: string = `${apiString}/api/v1.0/customer-portal/get/lodging-vendors/${request.brandId}?startDate=${request.startDate}&endDate=${request.endDate}${(request.vendorId === undefined ? "" : `&vendorId=${request.vendorId}`)}${(request.vendorGuid === undefined ? "" : `&vendorGuid=${request.vendorGuid}`)}${(request.guests === undefined ? "" : `&guests=${request.guests}`)}${(request.units === undefined ? "" : `&units=${request.units}`)}`;

      setFetchRequest({
        url: url,
        method: 'GET'
      });
    }

  }, [request]);

  useEffect(() => {
    if (fetchResponse.data) {
      // const response: GetLodgingVendorsResponse = fetchResponse.data; 
      setData(fetchResponse.data);
    }

  }, [fetchResponse.data]);

  useEffect(() => {
    if (fetchResponse.error) {
      setError(fetchResponse.error)
      console.log("fetch error", fetchResponse.error);
    }
  }, [fetchResponse.error]);

  useEffect(() => {
    setIsLoading(fetchResponse.isLoading);
  }, [fetchResponse.isLoading]);

  return ({ data, error, isLoading });
}

export default UseGetLodgingVendors;

export interface GetLodgingVendorsResponse extends FetchResponse {
  vendors: any;
}

export interface GetLodgingVendorsRequest {
  brandId: number;
  startDate: string;
  endDate: string;
  vendorGuid?: string;
  vendorId?: number;
  guests?: number;
  units?: number;
}